import axios from 'axios';
import { formatUnits } from '@ethersproject/units';
import { keccak256 } from '@ethersproject/keccak256';
import { toUtf8Bytes } from '@ethersproject/strings';
import { BigNumber } from '@ethersproject/bignumber';

const API_URL = 'https://three-name-api.herokuapp.com';
// const API_URL = 'http://localhost:9000';
const OPENSEA_API = 'https://api.opensea.io/api/v1';
const OPENSEA_TOKEN = 'f87d8ef226cd45b0b89d7c4b001ff74d';

let controller;
export async function getDomainAvailability(name, onChange) {
  if (controller) {
    controller.abort();
  }

  controller = new AbortController();

  axios({
    url: `${API_URL}/availability?name=${name}`,
    method: 'GET',
    signal: controller.signal,
    onDownloadProgress: (progressEvent) => {
      const dataChunk = progressEvent.currentTarget.response;
      try {
        onChange(JSON.parse(dataChunk.split('}{').join(',')));
      } catch (error) {
        // Ignore
      }
    },
  });
}

export async function getDomainListings(name) {
  const listings = { name };

  try {
    // Fetch ENS listing in OpenSea
    const labelHash = keccak256(toUtf8Bytes(name));
    const ensTokenId = BigNumber.from(labelHash).toString();
    const { data: listRes } = await axios.get(`${OPENSEA_API}/asset/0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85/${ensTokenId}/listings?limit=10`, {
      headers: {
        'X-API-KEY': OPENSEA_TOKEN,
      },
    });

    const firstListing = listRes.listings && listRes.listings.find((l) => l.cancelled !== true);

    if (firstListing) {
      const { data } = await axios.get(`${OPENSEA_API}/asset/0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85/${ensTokenId}/offers?limit=10`, {
        headers: {
          'X-API-KEY': OPENSEA_TOKEN,
        },
      });

      if (data && data.offers && data.offers.length) {
        const recentListing = data.offers.filter((l) => l.cancelled !== true).sort((a, b) => new Date(b.created_date) - new Date(a.created_date))[0];

        if (recentListing) {
          const price = recentListing.current_price && Number(formatUnits(Number(recentListing.current_price).toString().split('.')[0], '18'));

          listings.eth = {
            currentPrice: price === 0 ? 'BID' : price,
            currency: price === 0 ? '' : 'Ξ',
            link: `https://opensea.io/assets/ethereum/0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85/${ensTokenId}`,
          };
        }
      } else {
        const price = firstListing.current_price && Number(formatUnits(Number(firstListing.current_price).toString().split('.')[0], '18'));

        listings.eth = {
          currentPrice: price === 0 ? 'BID' : price,
          currency: price === 0 ? '' : 'Ξ',
          link: `https://opensea.io/assets/ethereum/0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85/${ensTokenId}`,
        };
      }
    }
  } catch (error) {
    // Do nothing
  }

  return listings;
}
